import React from "react";
import { Waves, Sprout, Wrench, Check } from "lucide-react";
import { services } from "../mock";
import Reveal from "./Reveal";

const iconMap = {
  waves: Waves,
  sprout: Sprout,
  wrench: Wrench,
};

const ServiceCard = ({ service, delay }) => {
  const Icon = iconMap[service.icon];
  return (
    <Reveal delay={delay}>
      <div className="group bg-white rounded-2xl overflow-hidden shadow-xl shadow-black/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 h-full flex flex-col">
        {/* Image with floating icon */}
        <div className="relative h-52 overflow-hidden">
          <img
            src={service.image}
            alt={`${service.title} services`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#071a2f]/40 to-transparent" />
          <div className="absolute -bottom-7 left-6 grid place-items-center h-16 w-16 rounded-full bg-gradient-to-br from-[#0a6bb0] to-[#062038] ring-4 ring-white shadow-lg glow-cyan-sm">
            <Icon className="h-8 w-8 text-[#4fd4ff]" strokeWidth={2} />
          </div>
        </div>

        <div className="p-6 pt-10 flex flex-col flex-1">
          <h3 className="font-display text-3xl text-[#071a2f] mb-4">
            {service.title.toUpperCase()}{" "}
            <span className="text-[#0a6bb0]">
              {service.accent.toUpperCase()}
            </span>
          </h3>

          <ul className="space-y-3 flex-1">
            {service.items.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-0.5 grid place-items-center h-5 w-5 rounded-full bg-[#35c6f4] shrink-0">
                  <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
                </span>
                <span className="text-slate-700 leading-snug">{item}</span>
              </li>
            ))}
          </ul>

          <div className="mt-6 pt-4">
            <p className="font-script text-2xl text-[#0a6bb0] swash inline-block">
              {service.slogan}
            </p>
          </div>
        </div>
      </div>
    </Reveal>
  );
};

const Services = () => {
  return (
    <section id="services" className="bg-gradient-to-b from-[#d6f3ff] via-white to-[#d6f3ff] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <Reveal>
          <div className="text-center mb-16">
            <p className="font-cond uppercase tracking-[0.3em] text-[#0a6bb0] text-sm mb-3">
              What We Do
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-[#071a2f]">
              OUR <span className="text-[#0aa5e0]">SERVICES</span>
            </h2>
            <div className="h-1.5 w-24 bg-gradient-to-r from-[#0aa5e0] to-[#4fd4ff] rounded-full mx-auto mt-5 glow-cyan-sm" />
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
          {services.map((s, i) => (
            <ServiceCard key={s.id} service={s} delay={i * 120} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
